import React, { useState } from 'react';
import { Button, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Grid } from '@material-ui/core'
import Skeleton from '@mui/material/Skeleton';
import { useSelector, useDispatch } from 'react-redux';
import { setLocation } from '../../../redux/actions';
import { userServices } from '../../../services/Services';
import { Cancel, CheckCircleOutline } from '@mui/icons-material';
import Footer from '../../footer/Footer';
import { useNavigate } from 'react-router-dom';

interface State {
    data: any,
    selected: any
}

interface IProps {
    history: any;
    // any other props that come into the component
}

function ViewDay(props: IProps) {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const stateR: any = useSelector(state => state);
    const [state, setState] = React.useState<State>({
        data: null,
        selected: null
    });

    const search = window.location.search.slice(1).split("%20").join(" ");
    const searchSplit = search.split("?");
    const cityName = window.location.search.slice(1).split("%20").join(" ").split('&')[0];
    const seconds: any = searchSplit[1];
    const date = new Date(seconds * 1000);
    const [lat, setLat] = useState(0);
    const [lng, setLng] = useState(0);
    const params = new URLSearchParams(window.location.search);
    
    const onClickBtn = () => {
        navigate({
            pathname: "/forecast",
            search: `?${cityName}&lat=${lat}&lng=${lng}`,
        });
    }

    // useEffect
    React.useEffect(() => {
        setLat(parseFloat(params.get("lat") || "0"));
        setLng(parseFloat(params.get("lng") || "0"));
        setState({ ...state, data: "" })
        const cityName = window.location.search.slice(1).split("%20").join(" ")
        dispatch(setLocation(cityName))
        const endpoint = `/day?q=${cityName}&lat=${lat}&lng=${lng}&units=${stateR.states.unit}`
        userServices
            .getReq(endpoint)
            .then((val) => (
                setState({ ...state, data: val })
            ))
    }, [stateR.states.unit]);

    const filtered = state.data?.hourly ? state.data.hourly.data : [];
    const unadvisableConditions = ["light rain", "rain", "snow", "fog", "sleet", "drizzle", "tornado"];
    const okayConditions = ["possible drizzle", "possible light rain"];
    var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    return (
        <div className="text-center">
            <Button variant="contained" onClick={onClickBtn} className="bg-yellow-500 hover:bg-yellow-600 font-bold m-2 text-center">Go Back</Button>
            {!state.data && <>
                <Skeleton className="h-20 w-1/2 mx-auto" />
                <Skeleton className="h-16 w-1/4 mx-auto" />
            </>}
            {state.data && <>
                <h1 className="text-3xl font bold text-center pb-3">Hourly Forecast for {cityName}</h1>

                <h2 className="text-5xl font bold text-center">
                   {days[new Date(filtered[0].time * 1000).getDay()]}, {months[new Date(filtered[0].time * 1000).getMonth()]} {new Date(filtered[0].time * 1000).getDate()}, {new Date(filtered[0].time * 1000).getFullYear()}
                </h2>
            </>}

            <div style={{ overflowX: 'auto', width: '100%' }}>
                <Grid container justifyContent="center">
                    <Grid item md={8}>
                        <TableContainer component={Paper} style={{ width: '100%', minWidth: '600px' }}>
                            <Table>
                                <TableHead className="bg-yellow-500 font-bold">
                                    <TableRow>
                                        <TableCell align="center" className="font-bold">Time</TableCell>
                                        <TableCell align="center" className="font-bold">Weather</TableCell> 
                                        <TableCell align="center" className="font-bold">Temperature</TableCell>
                                        <TableCell align="center" className="font-bold">Rain</TableCell>
                                        <TableCell align="center" className="font-bold">Wind</TableCell>
                                        <TableCell align="center" className="font-bold">Snow</TableCell>
                                        <TableCell align="center" className="font-bold">Inspection Conditions</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {!state.data &&
                                        <TableRow>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                        </TableRow>}
                                    
                                    {state.data && filtered.map((value: any, index: number) => (                                
                                        <TableRow key={Math.random()}>
                                            <TableCell align="center">
                                                {new Date(value.time * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
                                            </TableCell>
                                                
                                            <TableCell align="center">
                                                {value.summary}
                                            </TableCell>                                  
                                            
                                            <TableCell align="center">
                                                {value.temperature}
                                                {stateR.states.unit === "metric" ? "°C" : "°F"}
                                            </TableCell>
                                            
                                            <TableCell align="center">
                                                {value.precipType === "rain" ? value.precipIntensity : 0}
                                                {stateR.states.unit === "metric" ? "mm" : "in"}                                      
                                            </TableCell>
                                            
                                            <TableCell align="center">
                                                {value.windSpeed}
                                                {stateR.states.unit === "metric" ? "KM/H" : "MPH"}
                                            </TableCell>
                                                
                                            <TableCell align="center">
                                                {value.precipType === "snow" ? value.precipIntensity : 0}
                                                {stateR.states.unit === "metric" ? "mm" : "in"}
                                            </TableCell>
                                                
                                            <TableCell align="center">
                                                {
                                                    unadvisableConditions.includes(value.summary.toLowerCase()) ? (
                                                    <>
                                                        <Cancel fontSize="large" className="text-red-600 mx-auto" />
                                                    </>
                                                    ) : okayConditions.includes(value.summary.toLowerCase()) ? (
                                                    <>
                                                        <CheckCircleOutline fontSize="large" className="text-amber-600 mx-auto" />                                        
                                                    </>
                                                    ) : (
                                                    <>
                                                        <CheckCircleOutline fontSize="large" className="text-green-600 mx-auto" />
                                                    </>
                                                    )
                                                }
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </div>
            <Footer />
        </div>
    )
}
export default ViewDay;